<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">门禁记录</div>
      <el-form
        class="zj-search-form"
        ref="form"
        :model="form"
        :label-width="labelWidth"
      >
        <el-row>
          <el-form-item label="门禁点">
            <el-select v-model="doorIndexCode" placeholder="请选择" clearable>
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in doorOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人员姓名">
            <el-input
              v-model="personName"
              placeholder="请输入人员姓名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="时间段" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 68rem"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
        <div class="zj-table-container">
          <el-table
            v-loading="searching"
            element-loading-text="加载中..."
            :data="tableData"
            ref="multipleTable"
            border
            style="width: 100%"
            fixed
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="eventTime"
              label="开门时间"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column
              prop="personName"
              label="人员"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="doorName"
              label="门禁点名称"
            ></el-table-column>
            <el-table-column
              prop="eventType"
              label="事件类型"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.eventType === '进门'" style="color: #67C23A">进门</span>
                <span v-else-if="scope.row.eventType === '出门'" style="color: #409EFF">出门</span>
                <span v-else style="color: #909399">{{ scope.row.eventType }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="picUrl"
              label="开门照片"
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.picUrl"
                  :src="scope.row.picUrl"
                  :preview-src-list="[scope.row.picUrl]"
                  style="width: 60px; height: 60px"
                  fit="cover"
                ></el-image>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import { listDoorEvents, getDoorList } from "../../../apis/src/DoorAccessApi";
export default {
  name: "DoorEventView",
  controller: "UI",
  action: "doorEventView",
  data() {
    return {
      searching: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      date: [],
      doorIndexCode: null,
      personName: null,
      doorOptions: [],
    };
  },
  created: function () {
    this.loadOptions();
  },
  mounted: function () {
    this.search();
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    loadOptions() {
      getDoorList().then((r) => {
        this.doorOptions = r.data || [];
      }).catch((e) => {
        console.log(e);
      });
    },
    search() {
      this.searching = true;
      let startTime = null;
      let endTime = null;
      if (this.date && this.date.length === 2) {
        startTime = this.date[0].format("yyyy-MM-dd") + " 00:00:00";
        endTime = this.date[1].format("yyyy-MM-dd") + " 23:59:59";
      }
      let params = {
        doorIndexCode: this.doorIndexCode || undefined,
        personName: this.personName || undefined,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      listDoorEvents(params)
        .then((r) => {
          this.searching = false;
          this.tableData = r.rows || [];
          this.total = r.total || 0;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    onCancel() {
      this.date = [];
      this.doorIndexCode = null;
      this.personName = null;
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    formatDate(row, column) {
      let data = row[column.property];
      if (data == null || data === "") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
  },
};
</script>
